import { render, staticRenderFns } from "./Gestionar.vue?vue&type=template&id=083b446e"
import script from "./Gestionar.vue?vue&type=script&lang=js"
export * from "./Gestionar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports